import * as React from 'react';
import { cn } from "../lib/utils";

export const Card = React.forwardRef(({ className, style, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'rounded-xl text-[var(--c-foreground-ffffff)] shadow-soft',
      className
    )}
    style={{
      backgroundColor: 'color-mix(in srgb, var(--c-surface-0f172a) 50%, transparent)',
      borderColor: 'var(--c-border-232942)',
      borderWidth: '1px',
      ...style,
    }}
    {...props}
  />
));
Card.displayName = 'Card';

export const CardHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('flex flex-col space-y-1.5 p-6', className)} {...props} />
));
CardHeader.displayName = 'CardHeader';

export const CardTitle = React.forwardRef(({ className, ...props }, ref) => (
  // eslint-disable-next-line jsx-a11y/heading-has-content -- content passed via {...props}.children
  <h3
    ref={ref}
    className={cn(
      'text-xs font-semibold uppercase tracking-wider text-[var(--c-foreground-9ca3af)]',
      className
    )}
    {...props}
  />
));
CardTitle.displayName = 'CardTitle';

export const CardContent = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('p-6 pt-0', className)} {...props} />
));
CardContent.displayName = 'CardContent';
